import React, { useMemo } from "react";
import SpreadsheetViewer from "../SpreadsheetViewer";
import PDFViewer from "../pdfViewer";

export const FileViewer = ({
  fileType,
  fileData,
  pdfUrl,
  excelSheets,
  sheetData,
  onSpreadsheetChange,
  onPDFTextExtracted,
  viewerStyle,
  sheetConfigs,
  onCellSelect,
  isLinking,
  onDataExtracted,
  parseExtractedText,
  extractionConfig,
  fileName,
  onClose,
}) => {
  // Use the sheet data directly if it's in the correct format
  const viewerData = useMemo(() => {
    if (Array.isArray(sheetData) && sheetData.length > 0) {
      return sheetData;
    }
    return [];
  }, [sheetData]);

  if (fileType === "excel" && viewerData.length > 0) {
    return (
      <SpreadsheetViewer
        data={viewerData}
        onCellSelected={onCellSelect}
        onSheetChange={onSpreadsheetChange}
        isLinking={isLinking}
        style={viewerStyle}
        fileName={fileName}
        onClose={onClose}
      />
    );
  }

  switch (fileType) {
    case "pdf":
      return (
        <PDFViewer
          id="pdfViewer"
          url={pdfUrl}
          style={viewerStyle}
          onTextExtracted={onPDFTextExtracted}
          parseExtractedText={parseExtractedText}
        />
      );
    case "image":
      return (
        <img
          src={fileData}
          alt="Uploaded file"
          style={{ maxWidth: "100%", maxHeight: "500px" }}
        />
      );
    default:
      return null;
  }
};

export default FileViewer;
